module.exports = __webpack_public_path__ + "img/about-analysis.0474ec68.png";